import axios from './providers/axios';

const marketplaceModuleService = {
    getModules() {
        return axios.get(`/v1/admin/marketplaceModule/store`);
    },
    store(params = {}) {
        return axios.get(`/v1/admin/marketplaceModule/store`, { params });
    },
}

export default marketplaceModuleService;
